import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertDiamond = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-width:1.5px;}.a{stroke-linejoin:round;}.b{stroke-miterlimit:10;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "alert-diamond" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,16.5a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,16.5h0"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "b",
			x1: 12,
			y1: 13.5,
			x2: 12,
			y2: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M1.28,13.281a1.812,1.812,0,0,1,0-2.561l9.44-9.439a1.808,1.808,0,0,1,2.56,0l9.44,9.439a1.812,1.812,0,0,1,0,2.561L13.28,22.72a1.811,1.811,0,0,1-2.56,0Z"
		})
	]
});
export default SvgAlertDiamond;
